import dark from "./dark"

export default {
    ...dark,

    "--background-color": "#f6f6f6",
    "--page-background-color": "#ffffff",
    "--sidebar-obj-background-color": "#e8e8e8",
    "--obj-background-color": "#f3f3f3",
    "--obj-background-color-hover": "#dedede",
    "--obj-border-color": '#00000009',
    "--text-color": "#242424",
    "--text-color-alpha": "#07070788",
    "--tab-color": "#f7f7f7",
    "--tab-color-selected": "#eaeaea",



    "--highlight-tab": "#878787",

    "--highlight-emphasis": "#a8a8a2",
    "--highlight-primitive": "#a6982e",
    "--highlight-class": "#1d9828",
    "--highlight-attr": "#287d8d",
    "--highlight-params": "#242424",
    "--highlight-type": "#d2215c",
    "--highlight-meta": "rgba(211,33,92,0.93)",
    "--highlight-comment": "#0000006e",
    "--highlight-string": "#2c9160",
    "--highlight-keyword": "#3067ff",
    "--highlight-tag": "#3067ff",
}